import { TokenKind } from 'liquidjs';

import { defaultLiquidEngine } from '../../services/liquidEngineService';
import { BlockInstanceType } from '../../blocks/BlockInterface';
import { BlockPropertyTypeIsWhitelistedFilterPredicate } from './blockPropertyTypeIsWhitelistedFilterPredicate';
import { getBatchVariablesFromPropertyValue } from './getBatchVariablesFromPropertyValue';

export class BlockPropertyTypeIsWhitelistedAndTemplatedFilterPredicate extends BlockPropertyTypeIsWhitelistedFilterPredicate {
  shouldAllowBlockPropertyType(
    block: BlockInstanceType,
    blockPropertyName: string
  ): boolean {
    if (!super.shouldAllowBlockPropertyType(block, blockPropertyName)) {
      return false;
    }

    const propertyValue = block.properties[blockPropertyName];

    if (!propertyValue) {
      return false;
    }

    const extractedValue = getBatchVariablesFromPropertyValue(propertyValue);

    const templates = defaultLiquidEngine.parse(extractedValue);
    const variableTokens = templates.filter(
      (tpl: any) => tpl.token.kind === TokenKind.Output
    );

    return variableTokens.length > 0;
  }
}
